<aside class="breadcrumb mat-elevation-z2">
    <div fxLayout="row wrap" fxLayoutAlign="center center">
        <div fxFlex="100" fxFlex.gt-xs="60" fxFlex.gt-sm="60" class="title">
            <h4>{{ title }}</h4>
            <span class="description">{{ description }}</span>
        </div>
        <div fxFlex="100" fxFlex.gt-xs="40" fxFlex.gt-sm="40" class="breadcrumb-container">
            <ul *ngIf="!!urlConfig && !!urlConfig.length"
                class="d-flex align-items-center float-md-right float-sm-left breadcrumb-items">
                <li><a [routerLink]="['/dashboard']" replaceUrl>Home</a></li>
                <ng-container *ngFor="let url of urlConfig; index as i">
                    <li class="d-flex align-items-center breadcrumb-icon">
                        <mat-icon>chevron_right</mat-icon>
                    </li>
                    <li class="breadcrumb-item">
                        <ng-container [ngSwitch]="url.active">
                            <a *ngSwitchCase="true" [routerLink]="[url.path]" replaceUrl>{{ url.name }}</a>
                            <a *ngSwitchDefault class="disabled">{{ url.name }}</a>
                        </ng-container>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</aside>